/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Error_Route_DescInputs */

const en_ui_error_route_desc = /** @type {(inputs: Ui_Error_Route_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Something broke while showing this page. Your data is safe — try again or report the bug so it gets fixed.`)
};

const de_ui_error_route_desc = /** @type {(inputs: Ui_Error_Route_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beim Anzeigen dieser Seite ist etwas kaputtgegangen. Deine Daten sind sicher — versuch es noch einmal oder melde den Fehler, damit er behoben wird.`)
};

/**
* | output |
* | --- |
* | "Something broke while showing this page. Your data is safe — try again or report the bug so it gets fixed." |
*
* @param {Ui_Error_Route_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_error_route_desc = /** @type {((inputs?: Ui_Error_Route_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Error_Route_DescInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_error_route_desc(inputs)
	return de_ui_error_route_desc(inputs)
});